import store from '@/store'
import { sortBy } from 'lodash'

export function getCrewSize ({ PILOT = [], STEWARD = [] }) {
  const mode = store.getters.systemSettings.UI_SHOW_CREW_MODE
  const numOfPilots = PILOT.length
  const numOfStewards = STEWARD.length
  const num = numOfPilots + numOfStewards - 2

  const displayModes = {
    '2+N': num > 0 ? `[2 + ${num}]` : '[2 + 0]',
    'P+S': `[${numOfPilots} + ${numOfStewards}]`
  }

  return displayModes[mode] || displayModes['P+S']
}

export function getCrewMember (crew, crewMemberId) {
  return Object.values(crew).flat().find(({ id }) => id === crewMemberId)
}

export function getSortedCrewList (crew, sortByFn) {
  const crewList = Object.values(crew).flat()

  return sortBy(crewList, sortByFn)
}
